import {cs} from "../../react/chain-services";

export const ExpandPosition = ({next, minHeight, minWidth=undefined, dom, forcedLeft, forcedBottom}) => cs(
    () => {
        const rect = dom.getBoundingClientRect();
        const ww = window.innerWidth;
        const wh = window.innerHeight;
        const width = minWidth ?? rect.width;

        return next({
            width,
            ...!forcedBottom && minHeight && wh - (rect.top + rect.height) < minHeight ? (
                rect.top > minHeight ? {
                    bottom: wh - rect.top,
                } : {
                    top: 0,
                }
            ) : {
                top: rect.top + rect.height,
            },

            ...forcedLeft || rect.left < ww - (rect.left + width) ? {
                left: rect.left,
            } : {
                // right: ww - (rect.left + rect.width),
                right: ww - Math.max(rect.right, width) - getScrollbarWidth(),
            },
        });
    },
);

function getScrollbarWidth() {
    if (document.body.scrollHeight <= document.body.clientHeight) {
        return 0;
    }

    // Creating invisible container
    const outer = document.createElement('div');
    outer.style.visibility = 'hidden';
    outer.style.overflow = 'scroll'; // forcing scrollbar to appear
    // @ts-ignore
    outer.style.msOverflowStyle = 'scrollbar'; // needed for WinJS apps
    document.body.appendChild(outer);

    // Creating inner element and placing it in the container
    const inner = document.createElement('div');
    outer.appendChild(inner);

    // Calculating difference between container's full width and the child width
    const scrollbarWidth = (outer.offsetWidth - inner.offsetWidth);

    // Removing temporary elements from the DOM
    outer.parentNode.removeChild(outer);

    return scrollbarWidth;

}

